import { Component, Inject } from '@angular/core';
import { IAlertDialogData } from '../interfaces';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css'
})
export class AlertComponent {

  constructor(  @Inject(MAT_DIALOG_DATA) public data: IAlertDialogData) {

  }

}
